import { render, staticRenderFns } from "./RilevazioneDettagliata.vue?vue&type=template&id=99dbb310"
import script from "./RilevazioneDettagliata.vue?vue&type=script&lang=js"
export * from "./RilevazioneDettagliata.vue?vue&type=script&lang=js"
import style0 from "./RilevazioneDettagliata.vue?vue&type=style&index=0&id=99dbb310&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports